import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { TOAST_DURATION } from 'src/app/config/global.config';

export const httpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const notificationService = inject(NotificationService);

  return next(request).pipe(
    catchError((error) => {
      const errorsOrMessage = getErrorsOrMessage(error.error);
      let duration = Infinity;

      if (typeof errorsOrMessage === 'string') {
        duration = TOAST_DURATION;
      }

      notificationService.show(errorsOrMessage, 'error', { duration });
      return throwError(() => error);
    })
  );
};

function getErrorsOrMessage(error: any) {
  let errorsOrMessage = null;
  if (error?.error && Array.isArray(error?.error) && error?.error.length)
    // Return Validation Errors
    errorsOrMessage = error?.error?.map((err: any) => err.error);
  else if (typeof error?.error === 'string') {
    // Return the string error message directly
    errorsOrMessage = error.error;
  } else if (error.message)
    // Return message if no errors are present
    errorsOrMessage = error.message;
  // Provide a more user-friendly fallback message
  else
    errorsOrMessage = 'An unexpected error occurred. Please try again later or contact support.';

  return errorsOrMessage;
}
